import { Reducer } from '../redux';

import { AppActionType, ISetShowProgressAction } from './app-actions';
import { IAppState } from './state';

type AppActions = ISetShowProgressAction;

export const appInitialState: IAppState = {
    progress: false,
    progressText: null,
    redirect: null
};

export const appReducer: Reducer<IAppState, AppActions> = (state = appInitialState, action) => {
    switch (action.type) {
        case AppActionType.SET_SHOW_PROGRESS: {
            return {
                progress: action.show,
                progressText: action.text,
                redirect: action.redirect
            };
        }

        default: {
            return state;
        }
    }
};
